import { Component, OnInit, HostListener} from '@angular/core';
import { Router } from '@angular/router';
import { ClassesUtil } from '../../utils/classes-util';
import {TranslateService} from '@ngx-translate/core';
import {DTFService} from '../../dtf.service';
import { HeaderComponent } from '../header.component';
import { TranslateUtil } from '../../utils/translate-util';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { WindowRef } from '../../utils/window';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';


@Component({
    selector: 'div.mbfs-main-nav-links',
    imports: [SharedTranslateModule],
    templateUrl: './main-nav-links.component.html',
    styleUrls: ['./main-nav-links.component.scss'],
    providers: []
})
export class MainNavLinksComponent implements OnInit {
  public innerWidth: any;
  classesUtil: ClassesUtil;
  private _window: WindowRef;
  router: Router;
  currentCountry: string;
  isCanadaPortal = false;
  isFrench = false;
  language = '';
  targetRedirect = '';
  baseRedirect = '';
  usUrl: string;
  caUrl: string;
  azURL: string;

  constructor(classes: ClassesUtil, router: Router, public translate: TranslateService,
              public translateUtil: TranslateUtil, private dtfservice: DTFService, window: WindowRef) {
    this.classesUtil = classes;
    this.router = router;
    this._window = window;
}
  ngOnInit(): void {
    // Checks if the User is CA or US
    this.langInit();
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
    });
  }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

    // Checks if what language user is to redirect to correct href in link nav
    if (this.language === 'en-CA') {
        this.baseRedirect = this.usUrl + '/ca/en/';
    } else if (this.language === 'fr-CA') {
        this.baseRedirect = this.usUrl + '/ca/fr/';
    } else {
        this.baseRedirect = this.usUrl;
    }
    this.isFrench = ('fr-CA' === this.language) ? true : false; //checks if language is french or english for Canada
  }

  onClickOverly(e?: Event): void {
    let mainNavs = document.getElementsByClassName('mbfs-main-nav');

    // Remove 'active' class to hide side nav
    if (mainNavs.length) {
      this.classesUtil.removeClass(mainNavs[0], 'active');
      this.classesUtil.addClass(mainNavs[0], 'hidden');
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.innerWidth = (window as any).innerWidth;
  }

  navigateWithGA(path: string, page: string): void {
  const enableGA = sessionStorage.getItem('enableGA') === 'yes';

  let finalUrl = this.baseRedirect + path;

  if (enableGA && this.azURL) {
    this.translate.get('LoginModal.GARedirect').subscribe((data: any) => {
      const gaUrl = this.usUrl + data + 'true' + '&page=' + page;

      // First fire GA redirect
      this._window.nativeWindow.location.href = gaUrl;

      // Optional fallback (in case GA doesn't redirect back)
      setTimeout(() => {
        this._window.nativeWindow.location.href = finalUrl;
      }, 300);
    });
  } else {
    this._window.nativeWindow.location.href = finalUrl;
  }
}
}
